import api from "../utils/API";

// Base URL for your API
export const dealerService = {
  fetchList: async (payload) => {
    try {
      const response = await api.get("/admin/dealer", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  fetchOptionList: async () => {
    try {
      const response = await api.get("/admin/dealer/all");
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  createDealer: async (payload) => {
    try {
      const response = await api.post("/admin/dealer", payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  updateDealer: async (id, payload) => {
    try {
      const response = await api.put(`/admin/dealer/${id}`, payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  deleteDealer: async (id) => {
    try {
      const response = await api.delete(`/admin/dealer/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchDealerById: async (id) => {
    try {
      const response = await api.get(`/admin/dealer/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  resendInvitation: async (id) => {
    try {
      const response = await api.put(`/admin/dealer/resend-invitation/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  fetchNonApprovedDealers: async (payload) => {
    try {
      const response = await api.get("/admin/dealer/non-approve", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  dealerStatusApprove: async (id) => {
    try {
      const response = await api.put(`/admin/dealer/approve/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
};
